import React, { Component } from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state) {
    return {
        activePath: state.getIn(['ui', 'userProfile', 'menu', 'active']),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
